const locale = {
  contracted_projects: "Projetos contratados",
  other_products: "Outros produtos",
  search_projects: "Buscar projetos/tags",
  select_an_option: "Selecione uma opção",
  no_tags_available: "Nenhuma tag disponível",
  tag_not_found: "Tag não encontrada",
  select_a_tag: "Selecione uma tag",
  select_an_aoi: "Selecione uma AOI",
  aoi_not_found: "AOI não encontrada",
  no_aois_available: "Nenhuma AOI disponível",
  most_used_tags: "Tags mais utilizadas",
  add_tag: "Adicionar tag",
  delete_tag: "Excluir tag",
  add_aoi: "Adicionar AOI",
  delete_aoi: "Excluir AOI",
  search: "Buscar",
  header_title: "Amianto: Censo e Plano de Remoção",
  txt_footer_privacity: "Política de Privacidade e Cookies",
  txt_footer_legal: "Aviso legal",
  txt_description:
    "Os municípios são obrigados a realizar um censo de instalações e locais com presença de amianto, incluindo um cronograma para sua remoção, de acordo com a Lei 07/2022, de 8 de abril, sobre resíduos e solos contaminados para uma economia circular. Cumpra facilmente com a Lei 07/2022 com a nossa solução.\nA Agforest oferece uma solução completa para o censo de instalações com amianto, utilizando algoritmos de inteligência artificial e imagens de satélite para detectar a presença de amianto na sua localidade.",
  txt_description_title:
    "Censo de Instalações com Presença de Amianto nos Municípios - Obrigatório conforme a Lei 07/2022",
  txt_description_title_information:
    "Nesta ferramenta, você pode obter um orçamento para serviços de detecção remota de amianto para municípios, bem como análises que o ajudarão a compreender e fornecer informações relevantes para o seu cliente.",
  log_in: "Entrar",
  password: "Senha",
  user_name: "Nome de usuário",
  do_you_want_to_know_more: "Quer saber mais?",
  contact_us: "Fale conosco",
  solutions: "Soluções",
  asbestos_census: "Censo de amianto",
  water_leaks: "Vazamentos de água",
  co2_sinks: "Sumidouros de CO2",
  esg_transformation: "Transformação ESG",
  about_agforest: "Sobre a AGForest",
  blog: "Blog",
  press_room: "Sala de imprensa",
  success_stories: "Casos de sucesso",
  about_us: "Sobre nós",
  contact: "Contato",
  innovative_sme: "PME Inovadora",
  valid_until: "Válido até 24 de maio de 2027",
  privacyand_cookie_policy: "Política de Privacidade e Cookies",
  legal_notice: "Aviso legal",
  spain: "Espanha",
  success_cases: "Casos de sucesso",
  log_out: "Sair",
  visit: "Visitar",
  tags: "Tags",
  aois: "AOIs",
  image: "Imagem",
  category: "Categoria",
  description: "Descrição",
  title: "Título",
  grid_view: "Visão em grade",
  list_view: "Visão em lista",
};

export default locale;
